import { api } from '../api';
import type { EmailAccount } from '../api/email-accounts';

export class EmailAccountService {
  async getAccounts(): Promise<EmailAccount[]> {
    return await api.emailAccounts.list();
  }

  async deleteAccount(id: number): Promise<void> {
    await api.emailAccounts.delete(id);
  }
}

export const emailAccountService = new EmailAccountService();
